import styled from '@emotion/styled/macro';

export const StyledButton = styled.button`
  cursor: pointer;
  margin-top: 10px;
  padding: 2px 10px;
  border: 1px solid transparent;
  background: linear-gradient(0deg, #642780, #642780);
  border-radius: 100px;
  line-height: 28px;
  font-family: 'FuturaStd';
  font-weight: 700;
  font-size: ${12 / 16}rem;
  color: var(--brand-white);
  @media (min-width: 800px) {
    padding: 4px 20px;
    font-size: ${14 / 16}rem;
  }
  &[data-variant='secondary'] {
    border-color: var(--brand-primary);
    background: var(--brand-white);
    color: var(--brand-primary);
  }
  &[data-variant='text'] {
    color: var(--brand-primary);
    background: transparent;
    margin: 0;
    padding: 0;
    font-family: inherit;
  }
  &[data-variant='icon'] {
    display: flex;
    align-items: center;
    margin: 0;
    padding: 6px;
    line-height: 1;
    border-radius: 6px;
    border-color: var(--brand-primary);
    background: transparent;
  }
`;

export const StyledButtonLink = styled(StyledButton.withComponent('a'))`
  text-decoration: none;
  text-align: center;
`;
